import { Tooltip } from '@mui/material';
import { dateHeader, formatCellDate } from './timeModeCell';

export const makeChangeLogColumns = () => {
  return [
    {
      header: dateHeader('Timestamp'),
      accessorKey: 'createdDateTime',
      enableColumnFilter: true,
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: 'User',
      accessorKey: 'createdUserName',
      enableColumnFilter: true,
      size: 150,
      cell: ({ row }) => (
        <Tooltip title={row.original.createdUserId} disableInteractive>
          {row.original.createdUserName}
        </Tooltip>
      ),
    },
    {
      header: 'Message',
      accessorKey: 'message',
      size: 'auto',
    },
  ] as Array<any>;
};
